import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ScheduleRepository from '../../../repositories/ScheduleRepository';
import ScheduleDataRepository from '../../../../data/repositories/ScheduleDataRepository';
import IDHelpers from '../../../../core/helpers/IDHelper';
import { FilterAndMap } from '../getScheduleOnlyUseCase/saga';
import { getExams } from '../getExamsUseCase/saga';

export default function* execute(action: any): any {
  try {
    const { enabledExams } = action;
    yield put({ type: Types.GET_SCHEDULE_BY_DAY_REQUEST });
    const scheduleRepository: ScheduleRepository = new ScheduleDataRepository();
    const scheduleResponse = yield call(
      scheduleRepository.getScheduleByDay,
      action.startDate,
      action.period
    );
    if (!scheduleResponse) {
      yield put({
        type: Types.GET_SCHEDULE_BY_DAY_FAILURE,
        error: 'Ocurrió un error al leer el horario del día.'
      });
      return;
    }

    const meetings: any[] = scheduleResponse.items;

    const meetingsWithProfessor = meetings.map((m: any) => ({
      ...m,
      eventId: IDHelpers.generateID(),
      class: { linkZoom: '' }
    }));

    const nmeetingsF = FilterAndMap(meetingsWithProfessor);
    const exams = enabledExams ? yield getExams(action.period) : [];

    const filterExamsByDays = exams.filter(
      (el: any) =>
        (new Date(el.date).getDate() === new Date().getDate() &&
          new Date(el.date).getMonth() === new Date().getMonth() &&
          new Date(el.date).getFullYear() === new Date().getFullYear() &&
          new Date().getTime() <= Number(el.start)) ||
        (new Date().getTime() >= Number(el.start) &&
          new Date().getTime() <= Number(el.end))
    );

    let allMeetings: any[] = (nmeetingsF || []).concat(filterExamsByDays || []);
    allMeetings = allMeetings.sort((a: any, b: any) => {
      if (a.start > b.start) {
        return 1;
      }
      if (a.start < b.start) {
        return -1;
      }

      return 0;
    });

    let isCruce = false;

    const coursesLast =
      allMeetings.length > 2 ? allMeetings.slice(0, 2) : allMeetings;

    if (coursesLast.length === 2) {
      const course1 = coursesLast[0];
      const course2 = coursesLast[1];
      isCruce = course2.start > course1.start && course2.start < course1.end;
    }

    yield put({
      type: Types.GET_SCHEDULE_BY_DAY_SUCCESS,
      data: coursesLast,
      isCruce
    });
  } catch (error) {
    yield put({
      type: Types.GET_SCHEDULE_BY_DAY_FAILURE,
      error: 'Ocurrió un error al leer el horario.'
    });
    throw error;
  }
}
